export default "__VITE_ASSET__CYZTudEi__"